// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","collapsed":"Card_collapsed__1sHqG"};